import { httpRequest } from '@calendly/http-tools'

export const list = (userId) => httpRequest({
  url: `/api/users/${userId}/phone_numbers`,
  method: 'GET'
})

export const create = (userId, phoneNumber, code) => httpRequest({
  url: `/api/users/${userId}/phone_numbers`,
  method: 'POST',
  data: {
    e164_phone_number: phoneNumber,
    verification_code: code
  }
})

export const destroy = (userId, phoneNumberUuid) => httpRequest({
  url: `/api/users/${userId}/phone_numbers/${phoneNumberUuid}`,
  method: 'DELETE'
})

export const generateVerificationCode = (userId, phoneNumber) => httpRequest({
  url: `/api/users/${userId}/verification_codes`,
  method: 'POST',
  data: {
    e164_phone_number: phoneNumber
  }
})

export const setPrimary = (userId, phoneNumberUuid) => httpRequest({
  url: `/api/users/${userId}/phone_numbers/${phoneNumberUuid}/set_primary`,
  method: 'POST'
})
